<template>
  <!-- eslint-disable max-len -->
  <svg
    :aria-label="ariaLabel"
    :height="height"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
  >
    <path
      style="fill:#FFFFFF;"
      d="M49.9,14.5c0-2.2-0.2-4.4-0.6-6.6c-0.3-2.2-1.3-4.2-3-5.8c-1.4-1.4-3-2-4.7-2c-1.1,0-2,0-2.5,0
      c-1.1,0-1.9,0.2-2.7,0.2c-3.3,0.3-6.9,0.5-11,0.2l-9.3-0.6c-1.9-0.2-4.3,0-7.4,0.3C8,0.2,7.1,0.5,5.8,0.8c-1.6,0.5-3,1.4-4.1,2.7
      C0.8,4.5,0.2,5.8,0,7c0,0.8-0.2,1.9-0.3,3.4v13.1c0,1.2,0.2,3.3,0.3,5.8l0.3,10.5c0.2,2.2,0.6,3.9,1.4,5.5c1,1.7,2.2,2.7,3.8,3.1
      c0.8,0.3,1.1,0.3,1.3,0.3c0.8,0.3,1.7,0.5,2.8,0.6c0.9,0.2,1.9,0.2,2.5,0.2l5.8-0.2c2.5-0.2,3.9-0.2,4.6-0.2
      c4.1,0.2,7.1,0.3,9.1,0.6c1.9,0.2,5,0.2,9.8,0.2c0.6,0,1.4-0.2,2.7-0.3c1.7-0.3,3-1.2,3.9-2.7c0.6-0.9,1.1-1.9,1.3-2.8
      c0.5-1.6,0.6-2.8,0.6-3.6c0.2-3.8,0.2-6.6,0-8.4V14.5z"
    />
    <path
      style="fill:#231F20;"
      d="M9.5,0.2c-0.9,0-1.9,0.3-3.1,0.6C4.6,1.3,3.2,2.3,2,3.7C0.9,4.8,0.2,6,0.1,7.4c0,0.6-0.2,1.7-0.3,3.1
      v13.1c0,0.5,0,1.4,0,2.5c0,0.9,0,1.7,0.2,2.5l0.2,8.9c0,1.4,0,2.3,0,2.7c0.2,2.3,0.8,4.4,1.7,5.9c0.8,1.3,1.7,2,3,2.5
      c0.6,0.3,1.1,0.5,1.6,0.5c2.7,0.5,4.4,0.6,4.9,0.6l6.1-0.2c2.8-0.2,4.4-0.2,4.9-0.2c3.1,0.2,5.8,0.3,8.2,0.5
      c2.2,0.2,5.4,0.3,9.8,0.2c0.8,0,1.9-0.2,3.5-0.3c1.3-0.3,2.4-0.9,3.5-1.9c0.6-0.8,1.1-1.6,1.6-2.5c0.6-1.6,0.9-3.1,0.9-4.8
      c0.2-3.8,0.2-6.6,0-8.4l-0.2-17.5c0-2-0.2-4.2-0.5-6.6c-0.3-2.3-1.4-4.2-3.1-5.9C44.5,1,43,0.4,41.6,0.4c-2.7,0-4.4,0-5.2,0.2
      C33,1,29.2,1,25.1,0.7c-1.9-0.2-4.6-0.3-8.3-0.5C15-0.1,12.5,0.1,9.5,0.2 M16.1,1.6c1.9,0.2,4.6,0.3,8.2,0.5
      c4.9,0.3,9.1,0.2,12.6-0.2c0.8-0.2,2.2-0.2,4.7-0.2c1.3,0,2.4,0.5,3.6,1.4c1.4,1.4,2.4,3.1,2.7,5c0.3,2,0.5,4.4,0.5,6.7v24.7
      c0,0.8-0.2,2-0.5,3.6c-0.3,0.9-0.6,1.9-1.3,2.7c-0.8,1.1-1.7,1.7-3,2s-2.4,0.5-3.5,0.5H32c-5-0.5-10.2-0.6-15.4-0.5h-4.7
      c-1.3,0-3-0.2-5-0.6l-1.3-0.3c-0.9-0.3-1.7-1.1-2.4-2c-0.8-1.4-1.3-2.8-1.4-4.2c-0.2-0.9-0.2-1.9-0.2-2.8V13.2
      c0.2-1.4,0.2-2.5,0-3.8V8.3c0.2-2.2,1.1-3.9,3-5.3C6,2.1,7.8,1.6,9.5,1.5C12.2,1.6,14.4,1.6,16.1,1.6z"
    />
    <path
      style="fill:#CC0000;"
      d="M19.5,38.1h10.9l7.7-7.7V19.7L30.4,12H19.5l-7.7,7.7v10.8L19.5,38.1z"
    />
    <path
      style="fill:#231F20;"
      d="M38.6,29.1v-2.4c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.5,0.1-1.1,0.1-1.6c-0.2-0.6-0.2-1.4-0.2-2.2
      c0-0.4,0.1-0.8,0.3-1.3c0.2-0.3,0.2-0.6,0-1.1c-0.1-0.4-0.3-0.7-0.6-0.9c-0.4-0.5-0.7-0.6-0.9-0.8c-0.1,0-0.2-0.1-0.3-0.2
      c0-0.5-0.4-0.9-0.9-1.3c-0.5-0.6-0.9-1.3-1.6-1.7c-0.6-0.5-1.1-0.9-1.7-1.6c-0.2-0.2-0.3-0.5-0.8-0.9c-0.2-0.3-0.5-0.5-0.9-0.6
      c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0,0c-0.2-0.2-0.6-0.2-0.9-0.1c-0.6,0.2-1,0.2-1.2,0.2c-0.4,0-0.9,0-1.3,0c-0.4,0-0.8,0-1.3,0
      c-0.3,0.1-0.6,0.1-0.9,0.2c-0.3,0-0.7-0.1-0.9-0.2c-0.4,0-0.9,0-1.3,0c-0.4,0-0.8,0-1.3,0c-0.2,0-0.7,0-1.2-0.2
      c-0.3-0.1-0.7-0.1-0.9,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0.1c-0.4,0.1-0.7,0.3-0.9,0.6c-0.5,0.4-0.6,0.7-0.8,0.9
      c-0.6,0.7-1.1,1.1-1.7,1.6c-0.7,0.4-1.1,1.1-1.6,1.7c-0.5,0.4-0.9,0.8-0.9,1.3C13.1,18,13,18,12.9,18.1c-0.2,0.2-0.5,0.3-0.9,0.8
      c-0.3,0.2-0.5,0.5-0.6,0.9c-0.2,0.5-0.2,0.8,0,1.1c0.2,0.5,0.3,0.9,0.3,1.3c0,0.8,0,1.6-0.2,2.2c0,0.6,0,1.1,0.1,1.6
      c0,0.2-0.1,0.5-0.1,0.7v2.4c0,0.2,0,0.5-0.2,1.1c0,0.1,0,0.3,0,0.4c0,0.2,0,0.4,0.1,0.8c0.2,0.5,0.5,0.8,0.6,0.9
      c0.2,0.2,0.5,0.3,0.9,0.6c0.3,0.2,0.6,0.4,0.8,0.6c0.3,0.3,0.5,0.6,0.8,1c0.1,0.1,0.2,0.1,0.2,0.2l1.2,1.5c0.3,0.3,0.5,0.5,0.9,0.8
      c0.2,0.1,0.4,0.3,0.6,0.4l0.3,0.3c0.1,0.1,0.3,0.2,0.5,0.5c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.2,0.4,0.3,0.8,0.5
      c0.3,0.2,0.8,0.4,1.1,0.2c0.6-0.1,0.9-0.3,1.2-0.3l1.7,0.1c0.2,0,0.4,0.1,0.6,0.1l1,0l1,0c0.2,0,0.4-0.1,0.6-0.1l1.7-0.1
      c0.3,0,0.6,0.2,1.2,0.3c0.3,0.2,0.8,0,1.1-0.2c0.4-0.2,0.7-0.3,0.8-0.5c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1,0.1-0.2,0.1-0.3
      c0.2-0.3,0.4-0.5,0.5-0.5l0.3-0.3c0.2-0.1,0.4-0.3,0.6-0.4c0.4-0.3,0.6-0.5,0.9-0.8l1.2-1.5c0.1-0.1,0.2-0.1,0.2-0.2
      c0.3-0.3,0.5-0.6,0.8-1c0.3-0.2,0.6-0.4,0.8-0.6c0.4-0.3,0.7-0.4,0.9-0.6c0.1-0.1,0.4-0.4,0.6-0.9c0.1-0.3,0.2-0.6,0.1-0.8
      c0-0.2,0-0.3,0-0.4C38.6,29.6,38.6,29.3,38.6,29.1z M25.5,37.7c-0.2,0.1-0.3,0.1-0.5,0.1c-0.2,0-0.4-0.1-0.5-0.1c-0.4,0-1,0-1.5,0.1
      c-0.5-0.1-1-0.1-1.5-0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.2-0.1-0.4-0.2-0.5-0.2c-0.3-0.1-0.6-0.3-0.8-0.6c-0.5-0.5-0.6-0.8-0.6-0.8
      l-1.6-1.3c-0.5-0.5-1.1-0.9-1.6-1.4c-0.3-0.6-0.8-1.1-1.3-1.6c-0.6-0.3-1.1-0.8-1.4-1.4c-0.2-0.5-0.3-0.8-0.3-0.9c0-0.3,0-0.6,0-1.1
      c0.2-0.6,0.2-1.3,0.2-2c-0.2-0.8-0.2-1.4-0.2-2v-2c0-0.5,0-0.8,0-0.9c0-0.3,0.2-0.6,0.3-0.9c0.2-0.3,0.3-0.6,0.6-0.8
      c0.3-0.2,0.6-0.3,0.9-0.6c0.3-0.3,0.5-0.5,0.6-0.8c0.2-0.3,0.5-0.6,0.6-0.8c0.5-0.5,1.1-0.9,1.6-1.4c0.3-0.3,0.5-0.5,0.6-0.8
      c0.1-0.1,0.1-0.2,0.2-0.2l0.2-0.2c0.1-0.1,0.3-0.4,0.6-0.9c0.2-0.3,0.5-0.4,0.8-0.6c0.3-0.1,0.6-0.3,0.9-0.3c0.1,0,0.4,0,0.9,0
      c0.6,0,1.2,0,2,0.2l1.4-0.1l1.4,0.1c0.8-0.2,1.4-0.2,2-0.2c0.5,0,0.8,0,0.9,0c0.3,0,0.6,0.2,0.9,0.3c0.3,0.2,0.6,0.3,0.8,0.6
      c0.3,0.5,0.5,0.8,0.6,0.9l0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.3,0.3,0.5,0.6,0.8c0.5,0.5,1.1,0.9,1.6,1.4
      c0.1,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.3,0.5,0.6,0.8c0.3,0.3,0.6,0.4,0.9,0.6c0.3,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.3,0.6,0.3,0.9
      c0,0.1,0,0.4,0,0.9v2c0,0.6,0,1.2-0.2,2c0,0.7,0,1.4,0.2,2c0,0.5,0,0.8,0,1.1c0,0.1-0.1,0.4-0.3,0.9c-0.3,0.6-0.8,1.1-1.4,1.4
      c-0.5,0.5-1,1-1.3,1.6c-0.5,0.5-1.1,0.9-1.6,1.4l-1.6,1.3c0,0-0.1,0.3-0.6,0.8c-0.2,0.3-0.5,0.5-0.8,0.6c-0.2,0.1-0.4,0.2-0.5,0.2
      c-0.2,0-0.3-0.1-0.5-0.1c-0.4,0-1,0-1.5,0.1C26.5,37.7,26,37.7,25.5,37.7z"
    />
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon],
  props: {
    ariaLabel: {
      type: String,
      default: 'Stop'
    }
  }
};
</script>
